import React, { useState } from "react";
import Button from "../../components/ui/button";
import { navLogo } from "../../assets";
import { useNavigate } from "react-router-dom";

const Navbar = () => {
  const [activeTab, setActiveTab] = useState(0);
  const navigate = useNavigate();

  const navTabs = ["Home", "About Us", "Contact Us"];

  return (
    <div className="w-full px-4 sm:px-8 md:px-16 py-5">
      <div className="flex flex-col gap-4 items-center justify-between sm:flex-row">
        {/* Logo */}
        <img src={navLogo} alt="Logo" className="h-10 w-auto" />

        {/* Navigation Tabs */}
        <div className="flex flex-wrap justify-center gap-6 sm:gap-8">
          {navTabs.map((tab, index) => (
            <div
              key={tab}
              onClick={() => {
                setActiveTab(index);
                if (tab === "Home") navigate("/");
                if (tab === "About Us") navigate("/about");
                if (tab === "Contact Us") navigate("/help");
              }}
              className={`font-lato text-[1.125rem] font-[400] cursor-pointer transition-colors ${
                activeTab === index ? "text-green-600" : "text-[#121212]"
              }`}
            >
              {tab}
            </div>
          ))}
        </div>

        {/* CTA Button */}
        <div className="mt-2 sm:mt-0">
          <Button
            text="Get an Appointments"
            theme="primary"
            className="rounded-[0.5rem] px-[2rem] py-[1rem]"
            onClick={() => navigate("/get-appointment")}
          />
        </div>
      </div>
    </div>
  );
};

export default Navbar;
